/** Public pages live at the environment domain; account flows live on dashboard. */
export function domains(hostname = window.location.hostname) {
  for (const root of ['staging.trade-fluency.com', 'trade-fluency.com']) {
    if (hostname === root || hostname === `dashboard.${root}`) {
      return {
        publicOrigin: `https://${root}`,
        dashboardOrigin: `https://dashboard.${root}`,
        isDashboard: hostname === `dashboard.${root}`,
      };
    }
  }
  // Keep local development and preview hosts on one origin.
  return { publicOrigin: '', dashboardOrigin: '', isDashboard: false };
}

export const publicPaths = ['/about', '/status', '/health', '/terms', '/privacy'];
export const appPaths = [
  '/login', '/signup', '/forgot-password', '/dashboard', '/portfolio', '/instruments',
  '/trades', '/trade', '/notifications', '/messages', '/approvals', '/positions',
  '/config', '/profile', '/brokers', '/strategies', '/indicators', '/guide', '/help',
];

function matches(path: string, routes: string[]) {
  return routes.some((route) => path === route || path.startsWith(`${route}/`));
}

export function canonicalUrl(hostname: string, path: string, search = '', hash = '') {
  const site = domains(hostname);
  if (!site.publicOrigin) return null;
  const origin = site.isDashboard && matches(path, publicPaths)
    ? site.publicOrigin
    : !site.isDashboard && matches(path, appPaths) ? site.dashboardOrigin : null;
  return origin ? `${origin}${path}${search}${hash}` : null;
}

export const publicUrl = (path: string) => `${domains().publicOrigin}${path}`;
export const dashboardUrl = (path: string) => `${domains().dashboardOrigin}${path}`;
